import { render, staticRenderFns } from "./AlternativeAuthForm.vue?vue&type=template&id=9cfa5f66&"
import script from "./AlternativeAuthForm.vue?vue&type=script&lang=js&"
export * from "./AlternativeAuthForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports